import { Calendar } from '#icons/Calendar';
import { IconWrapper, InputWrapper, StyledInputField } from '../../styles';
import { IconButton } from '../../../../IconButton';
import type React from 'react';

type CustomInputDatepickerProps = {
  value?: string;
  onClick?: () => void;
  placeholderText?: string;
  disabled?: boolean;
  selectedDateIsHoliday?: boolean;
  ref?: React.Ref<HTMLDivElement>;
};

function CustomInputDatepicker({
  onClick,
  value,
  disabled,
  placeholderText,
  selectedDateIsHoliday,
  ref,
}: CustomInputDatepickerProps) {
  return (
    <InputWrapper onClick={onClick} ref={ref}>
      <StyledInputField
        isHoliday={selectedDateIsHoliday}
        value={value}
        readOnly
        disabled={disabled}
        placeholder={placeholderText}
      />
      <IconWrapper disabled={disabled}>
        <IconButton
          data-testid="toggle-datepicker"
          onClick={onClick}
          variant="secondary"
          disabled={disabled}
        >
          <Calendar />
        </IconButton>
      </IconWrapper>
    </InputWrapper>
  );
}

export default CustomInputDatepicker;
